import React, { useState } from "react";
import ModalVideo from "react-modal-video";
import CountUp from "react-countup";
import "react-modal-video/css/modal-video.css";
import { Link } from "react-router-dom";
import Technlogiesicon from "./technlogiesicon";
// import ServiceItem from "../service/ServiceItem"
import ServiceItem from "../../service/ServiceItem"
import SliderTwo from "./SliderTwo";
// import HomeTowTeamArea from "../home2/HomeTowTeamArea";
import SliderPicture from "./SliderPicture";
function ServiceDetailsWrap() {
  const [isOpen, setOpen] = useState(false);
  return (
    <>
      <div className="service-section2 pt-120 ">
        <div className="container">
          <div className="row d-flex justify-content-lg-start justify-content-center gy-5">
            <div className="col-lg-5 col-md-5">
              <div
                className="section-card service-details-card wow animate fadeInDown"
                data-wow-duration="1.5s"
                data-wow-delay="0.5s"
              >
                <h2 className="cusm-front">Managed Service Provider</h2>
                <p className="cusm-front cusm-lineheight text_jus">
                As a leading web app development company, we deliver services that improve the business process, reduce costs, and bring efficiency to performance.


             
                </p>
                <Link
                  to={"#"}
                  class="eg-btn hover-btn sectoin-card-btn hover-btn-cusm"
                >
                  <span style={{ color: "white" }}>
                    Download Profile{" "}
                    <img
                      src={
                        process.env.PUBLIC_URL + "/images/icon/arrow-servc.svg"
                      }

                      alt="images"
                    />
                  </span>
                </Link>
              </div>

            </div>
            <div className="col-lg-7 col-md-7">
              <div className="section-title text-center "></div>
              <div className="service-details-area">
                <div className="service-details-img">
                  <img
                    // src={process.env.PUBLIC_URL + "/images/bg/sdetails1.png"}
                    // src="https://geniusfixers-usa.web.app/images/bg/UntDDDitled design.png"
                    src="./images/bg/graphic_0001_virtual-finance.png"
                    alt="images"
                  />
                </div>

                {/* <div className="work-process">
                  <h3>Work Process</h3>
                  <div className="row g-3">
                    <div className="col-lg-3 col-md-6 col-sm-3 col-6">
                      <div className="work-pro-item">
                        <img
                          src={
                            process.env.PUBLIC_URL + "/images/icon/workp1.svg"
                          }
                          alt="images"
                        />
                        <h4>
                          <Link to={"#"}>Research</Link>
                        </h4>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-3 col-6">
                      <div className="work-pro-item">
                        <img
                          src={
                            process.env.PUBLIC_URL + "/images/icon/workp2.svg"
                          }
                          alt="images"
                        />
                        <h4>
                          <Link to={"#"}>Idea</Link>
                        </h4>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-3 col-6">
                      <div className="work-pro-item">
                        <img
                          src={
                            process.env.PUBLIC_URL + "/images/icon/workp3.svg"
                          }
                          alt="images"
                        />
                        <h4>
                          <Link to={"#"}>Develop</Link>
                        </h4>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-3 col-6">
                      <div className="work-pro-item">
                        <img
                          src={
                            process.env.PUBLIC_URL + "/images/icon/workp4.svg"
                          }
                          alt="images"
                        />
                        <h4>
                          <Link to={"#"}>Launch</Link>
                        </h4>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>

            {/* deltail */}
            <div className="col-lg-12 col-md-12">
              <div className="section-title text-center "></div>
              <div className="service-details-area">
                <div className="service-details-content bg-white">
                  {/* section one ----------------------------------------------------------------------------------------- */}

     



                    




        
                  {/* tools */}
                  {/* <div className=" work-process mt-5">

                    <div className="row g-3">
                      <div className="col-lg-3 col-md-4 col-sm-3 col-6">
                        <div className="work-pro-item">
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/icon/MicrosoftTeams-image (5).png"
                            }
                            alt="images"
                          />
                          <h5 className="color-black cusm-front">
                            Android App Development
                          </h5>
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-4 col-sm-3 col-6">
                        <div className="work-pro-item">
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/icon/MicrosoftTeams-image (7).png"
                            }
                            alt="images"
                          />
                          <h5 className="color-black cusm-front">
                            iOS App Development
                          </h5>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-4 col-sm-3 col-6">
                        <div className="work-pro-item">
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/icon/MicrosoftTeams-image (8).png"
                            }
                            alt="images"
                          />
                          <h5 className="color-black cusm-front">
                            Enterprise App Development
                          </h5>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-4 col-sm-3 col-6">
                        <div className="work-pro-item">
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/icon/workp3.svg"
                            }
                            alt="images"
                          />
                          <h5 className="color-black cusm-front">
                            Hybrid App Development
                          </h5>
                        </div>
                      </div>



                    </div>
                  </div> */}



                  {/* Section two ------------------------------------------------------------------------------------------ */}
                  {/* sass */}
                  <div className="row g-3 service-intro-row mt-5">
                    <h2 style={{ color: "#cf2534" }} className="cusm-front pt-4 ">
                    Command IT 
                    </h2>

                    <div className="col-md-7 col-sm-6">

                      <h3
                        style={{ color: "#cf2534" }}
                        className=" cusm-front  text-just"
                      >
                    What Exactly Are Managed IT Services? 
                      </h3>



                      <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
                      Managed services allow businesses to outsource some or all of their technology administration in order to streamline IT operations and lower costs. As a Managed Services Provider (MSP),Genius Fixers objective is to collaborate with your business to deliver IT support that meets your demands and relieves you of the responsibility of overseeing your company's business technology services. 
                      </p>
                      <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
                      A co-managed IT services arrangement working with your current in-house team can be one option, as can totally outsourcing your IT requirements, a one-time IT consulting project, or both. One of the best MSPs in the United States, Genius Fixers offers cheap pricing based on a flat-rate monthly subscription service that includes unlimited remote support from a help desk in the United States. Set up a call with us to discuss how Genius Fixers managed IT services and support may help YOUR company expand by getting in touch with us. 

  
                      </p>


                    </div>
                    <div className="col-md-5 col-sm-5">
                      <img
                        src={
                          process.env.PUBLIC_URL + " /images/bg/20944989.jpg"
                        }
                        alt="images"
                      />
                    </div>

                  </div>

                  {/* FRONTNED  */}
                  <div className="row g-3 service-intro-row mt-5">
                  <div className="col-md-5 col-sm-5">
                      <img
                        src={
                          process.env.PUBLIC_URL + " /images/bg/Wavy_Bus-27_Single-06 copy.jpg"
                        }
                        alt="images"
                      />
                    </div>

                  <div className="col-md-7 col-sm-6 ">
                      <h3
                        style={{ color: "#cf2534" }}
                        className=" cusm-front  text-just"
                      >
                       US-Based 24/7 Service Desk 
                      </h3>


                      <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
                      Many service providers ensure that your call will be returned as soon as possible—but by whom? 

At Genius Fixers, we provide a US-based support desk manned by qualified technicians (not call agents) who can typically resolve issues right away. Additionally, we allow you to "self-triage" any issue, so you can contact us 24/7/365 for any issue, no matter how big or small. A managed service provider offers great IT help desk solutions, so be sure you're receiving the best! Distance IT Support End-user problems, like being unable to connect to the internet, having a slow or "frozen" computer, forgetting passwords, being unable to print, or having trouble signing in, are the ones that require tech help the most frequently. These IT issues can be resolved remotely by our team using tools that give us complete access to your network and systems. In order to keep your workforce functioning cost-effectively, Genius Fixers offers remote support technology services that include software installation, cloud services, sophisticated troubleshooting and repairs of apps, and more.

                      </p>
                     

                    </div>



                  </div>


                  <div className="row g-3 service-intro-row mt-5">
                 
                    <div className="col-md-7 col-sm-6 ">
                      <h3
                        style={{ color: "#cf2534" }}
                        className=" cusm-front  text-just"
                      >
On-Site Support 
                      </h3>


                      <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
                      Many IT support duties are now completed remotely as cloud-based services gain popularity. However, there are still some problems that call for or need on-site solutions. Any issues that Genius Fixers cannot resolve remotely are always resolved on-site by a specialist. Additionally, we provide scheduled on-site services. Find out which of our on-site assistance packages best meets your needs by speaking with us about them. 

                      </p>
                      



                    </div>
                    <div className="col-md-5 col-sm-5">
                      <img
                        src={
                          process.env.PUBLIC_URL + " /images/bg/site_support_2.jpg"
                        }
                        alt="images"
                      />
                    </div>


                  </div>









                  <div className="row g-3 service-intro-row mt-5">
                  <div className="col-md-5 col-sm-5">
                      <img
                        src={
                          process.env.PUBLIC_URL + " /images/bg/20945597.jpg"
                        }
                        alt="images"
                      />
                    </div>
                    <div className="col-md-7 col-sm-6 ">
                      <h3
                        style={{ color: "#cf2534" }}
                        className=" cusm-front  text-just"
                      >
                   Cyber Security 

                      </h3>


                      <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
                     
                      Cybersecurity, Every company is extremely concerned about security, yet very few have the means to stop online threats and attacks. One of the main reasons companies choose a managed services provider is to have access to advanced, round-the-clock cybersecurity protection. Genius Fixers managed security services are described in more detail here. 
                      </p>




                    </div>


                  </div>



                  <div className="row g-3 service-intro-row mt-5">
                    <div className="col-md-7 col-sm-6 ">
                      <h3
                        style={{ color: "#cf2534" }}
                        className=" cusm-front  text-just"
                      >
                     Server and Workstation Management 

                      </h3>


                      <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
                        
                      One of the most significant ways service providers can safeguard your organisation against cyberattacks is to maintain your software and operating systems up to date. In addition to missing out on new features, failing to do so leaves you vulnerable to hackers searching for organisations that haven't bothered with the most recent security patches. Genius Fixers will assume control of this crucial duty if you lack the personnel to maintain it on a regular basis, ensuring company continuity with automated software upgrades, patch solutions, and security updates, including antivirus and antispam. 

                      </p>
                  



                    </div>
                    <div className="col-md-5 col-sm-5">
                      <img
                        src={
                          process.env.PUBLIC_URL + " /images/bg/Wavy_Tech-25_Single-01.jpg"
                        }
                        alt="images"
                      />
                    </div>

                  </div>

                  <div className="row g-3 service-intro-row mt-5">
                  <div className="col-md-5 col-sm-5">
                      <img
                        src={
                          process.env.PUBLIC_URL + " /images/bg/19198939.jpg"
                        }
                        alt="images"
                      />
                    </div>
                    <div className="col-md-7 col-sm-6 ">
                      <h3
                        style={{ color: "#cf2534" }}
                        className=" cusm-front  text-just"
                      >
                      Network Monitoring and Management 


                      </h3>


                      <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
                      Want to maintain peak performance in your IT environment? All the devices in your network, including routers, firewalls, and switches, are continuously monitored and managed by managed services. Our automated systems proactively monitor your computers, servers, and other network components to find and report device and connection issues.

                      </p>
                     


                    </div>


                  </div>
                  <div className="row g-3 service-intro-row mt-5">
                    <div className="col-md-7 col-sm-6 ">
                      <h3
                        style={{ color: "#cf2534" }}
                        className=" cusm-front  text-just"
                      >
                       Hardware and Software Procurement 


                      </h3>


                      <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
                      Hardware and Software Procurement 

It takes a lot of time to evaluate, buy, and install gear and software. The experts at Genius Fixers can advise you on the best licencing contracts, hardware, and software options for your company. From installing, maintaining, and updating your systems to retiring outdated hardware, we handle the entire procurement process. All of the main hardware and software companies are partners with us. Because of our purchasing power in large quantities and our close ties to numerous important wholesalers, our solutions also allow for lower pricing. 

  

  

  


                      </p>

      




                    </div>
                    <div className="col-md-5 col-sm-5">
                      <img
                        src={
                          process.env.PUBLIC_URL + " /images/bg/19199655.jpg"
                        }
                        alt="images"
                      />
                    </div>

                  </div>


                  <div className="row g-3 service-intro-row mt-5">
                  <div className="col-md-5 col-sm-5">
                      <img
                        src={
                          process.env.PUBLIC_URL + " /images/bg/66061.jpg"
                        }
                        alt="images"
                      />
                    </div>
                    <div className="col-md-7 col-sm-6 ">
                      <h3
                        style={{ color: "#cf2534" }}
                        className=" cusm-front  text-just"
                      >
                    Backup and Disaster Recovery (BDR) 


                      </h3>


                      <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
                      Businesses nowadays are producing more data than ever before, and safeguarding that data is crucial. In order to ensure business continuity, a reliable data backup and disaster recovery solution is required. One of the most crucial expenditures for safeguarding your business is your data backup and disaster recovery solution. You may choose, implement, and manage the backup and recovery solution that is appropriate for your company with the aid of Genius Fixers. Many of our managed services come with a variety of choices to satisfy your backup and recovery requirements. 

                      </p>
                     


                    </div>


                  </div>



                  <div className="row g-3 service-intro-row mt-5">
                    <div className="col-md-7 col-sm-6 ">
                      <h3
                        style={{ color: "#cf2534" }}
                        className=" cusm-front  text-just"
                      >
                      Microsoft Office 365 Licensing 


                      </h3>


                      <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
                      Microsoft Gold Partner Genius Fixers has more than 16 years of experience offering services and solutions for Microsoft products, such as Office 365, Azure, and SharePoint. We assist your company in choosing the appropriate Microsoft plans and products, assist you in moving away from your present solution, and offer continuing management in addition to our US-based 24/7/365 service desk. Your productivity software is yet another crucial managed services pillar! 

  

  

  


                      </p>

      




                    </div>
                    <div className="col-md-5 col-sm-5">
                      <img
                        src={
                          process.env.PUBLIC_URL + " /images/bg/docs.jpg"
                        }
                        alt="images"
                      />
                    </div>

                  </div>



                  <div className="row g-3 service-intro-row mt-5">
                  <div className="col-md-5 col-sm-5">
                      <img
                        src={
                          process.env.PUBLIC_URL + " /images/bg/180620_customer_support_frequently_asked_questions_vector_concept.jpg"
                        }
                        alt="images"
                      />
                    </div>
                    <div className="col-md-7 col-sm-6 ">
                      <h3
                        style={{ color: "#cf2534" }}
                        className=" cusm-front  text-just"
                      >
                   Your Own Device and Mobile Support 


                      </h3>


                      <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
                      Mobile device security is a challenge when employees use their personal devices at work. Mobile devices boost employee productivity, but poorly managed ones pose a serious security threat. Our managed services are relied upon by many clients that need guidance on how to safeguard their mobile environment. Usually, we begin by developing a personalised Bring Your Own Device policy. We can also assist you in assessing a Mobile Device Management (MDM) solution and other recommended safeguards for your devices. 

                      </p>
                     


                    </div>


                  </div>

                  <div className="row g-3 service-intro-row mt-5">
                    <div className="col-md-7 col-sm-6 ">
                      <h3
                        style={{ color: "#cf2534" }}
                        className=" cusm-front  text-just"
                      >
                    Cloud Services


                      </h3>


                      <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
                      Migration and optimization 24x7 Event Management for UCC Services. Support for operating systems, applications, databases, business continuity, and connectivity are all provided in addition to real-time monitoring of computing, storage, switches, hypervisors, and converged infrastructure. 

Phone, UC, Collaboration & Contact Center of Network Services – SD WAN, Network, Wireless & Optimization 

  

  

  


                      </p>

      




                    </div>
                    <div className="col-md-5 col-sm-5">
                      <img
                        src={
                          process.env.PUBLIC_URL + " /images/bg/3y_8dm6utb441hmurbgelq6irj7bsq0.jpg"
                        }
                        alt="images"
                      />
                    </div>

                  </div>



                  <div className="row g-3 service-intro-row mt-5">
                  <div className="col-md-5 col-sm-5">
                      <img
                        src={
                          process.env.PUBLIC_URL + " /images/bg/data_analytics_and_rocket_launching.jpg"
                        }
                        alt="images"
                      />
                    </div>
                    <div className="col-md-7 col-sm-6 ">
                      <h3
                        style={{ color: "#cf2534" }}
                        className=" cusm-front  text-just"
                      >
                 Network Optimization 


                      </h3>


                      <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
                      According to the most recent report by Gartner Group, 80% of businesses overpay between 6 and 8% per month for their telecoms services, and the majority of companies overspend by 22-26% for I.T. services. Genius Fixers will ensure that your network expenses and bandwidth needs are continuously optimised as your dependable IT partner. 

  

 

                      </p>
                     


                    </div>


                  </div>


                  
                  












             
 













                







                </div>




  


                {/* <div className="work-process">
                  <h3>Work Process</h3>
                  <div className="row g-3">
                    <div className="col-lg-3 col-md-6 col-sm-3 col-6">
                      <div className="work-pro-item">
                        <img
                          src={
                            process.env.PUBLIC_URL + "/images/icon/workp1.svg"
                          }
                          alt="images"
                        />
                        <h4>
                          <Link to={"#"}>Research</Link>
                        </h4>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-3 col-6">
                      <div className="work-pro-item">
                        <img
                          src={
                            process.env.PUBLIC_URL + "/images/icon/workp2.svg"
                          }
                          alt="images"
                        />
                        <h4>
                          <Link to={"#"}>Idea</Link>
                        </h4>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-3 col-6">
                      <div className="work-pro-item">
                        <img
                          src={
                            process.env.PUBLIC_URL + "/images/icon/workp3.svg"
                          }
                          alt="images"
                        />
                        <h4>
                          <Link to={"#"}>Develop</Link>
                        </h4>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-3 col-6">
                      <div className="work-pro-item">
                        <img
                          src={
                            process.env.PUBLIC_URL + "/images/icon/workp4.svg"
                          }
                          alt="images"
                        />
                        <h4>
                          <Link to={"#"}>Launch</Link>
                        </h4>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        {/* <div className="achievment-section2">
        <div className="container">
          <div className="row d-flex align-items-center g-4">
            <div className="col-lg-4 col-md-5 col-sm-6">
              <div className="achv-vdo2">
                <img
                  src={process.env.PUBLIC_URL + "/images/bg/ach-vdo2.png"}
                  alt="images"
                />
                <div className="video-play">
                  <div
                    onClick={() => setOpen(true)}
                    className="video-open video-icon"
                  >
                    <i className="bx bx-play" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-8 col-md-7 col-sm-6">

              <div className="quote-text ms-auto">
                <h4 className="cusm-front" style={{color:"white"}}>OUR ACHIEVEMENTS </h4>
                <p  className="cusm-front" style={{color:"white"}}>
                At Genius Fixers, we take great pride in our achievements and are constantly striving to improve and innovate in the technology industry. Here are some of our most notable accomplishments: 

 
                </p>
              </div>
            </div>

    




          </div>
          
        </div>
      </div> */}
      </div>
    </>
  );
}

export default ServiceDetailsWrap;
